/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
import Dictionary from '../interfaces/dictionary';

export enum BalanceType {
  Addition = 'addition',
  Subtraction = 'subtraction'
}

export enum BalanceStatus {
  Waiting = 'waiting',
  Approved = 'approved',
  Canceled = 'canceled'
}

export enum TransactStatus {
  Done = 'done',
  Undone = 'undone'
}

export enum PaymentBalanceType {
  Transfer = 0,
  CashDeposit = 1,
  Pix = 2,
  CreditCard = 3,
  DebitCard = 4,
  BankSlip = 5,
  PixOnline = 6,
  Reversal = 99
}

export const PaymentBalanceTypeList: Dictionary[] = [
  { key: 0, value: 'Tranferência' },
  { key: 1, value: 'Depósito em dinheiro' },
  { key: 2, value: 'Pix' },
  { key: 3, value: 'Cartão crédito' },
  { key: 4, value: 'Cartão débito' },
  { key: 5, value: 'Boleto bancário' },
  { key: 6, value: 'Pix Online' },
  { key: 99, value: 'Estorno (Devolução)' }
];
